var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedKlay0)",
    d: "M12.244 5.143a6.6 6.6 0 0 1 4.153 1.599l-7.641 7.654z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedKlay1)",
    d: "M12.244 5.143a6.6 6.6 0 0 1 4.153 1.599l-7.641 7.654z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedKlay2)",
    d: "m12.87 12.017l4.406-4.423a6.93 6.93 0 0 1 0 8.812z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedKlay3)",
    d: "m12.87 12.017l4.406-4.423a6.93 6.93 0 0 1 0 8.812z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedKlay4)",
    d: "m5.156 11.572l5.366-5.388l-3.823 10.183a6.9 6.9 0 0 1-1.543-4.795"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedKlay5)",
    d: "m5.156 11.572l5.366-5.388l-3.823 10.183a6.9 6.9 0 0 1-1.543-4.795"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedKlay6)",
    d: "m7.616 17.259l4.41-4.385l4.406 4.385a6.85 6.85 0 0 1-4.406 1.598a6.86 6.86 0 0 1-4.41-1.598"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedKlay7)",
    d: "m7.616 17.259l4.41-4.385l4.406 4.385a6.85 6.85 0 0 1-4.406 1.598a6.86 6.86 0 0 1-4.41-1.598"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedKlay0",
    x1: 10.965,
    x2: 10.965,
    y1: 5.143,
    y2: 25.47,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E91A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedKlay1",
    x1: 21.733,
    x2: 4.708,
    y1: 30.234,
    y2: 10.764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D0097",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D0097",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedKlay2",
    x1: 3.15,
    x2: 3.15,
    y1: 1.328,
    y2: 22.673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E91A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedKlay3",
    x1: 16.895,
    x2: -0.209,
    y1: 27.676,
    y2: 3.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D0097",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D0097",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedKlay4",
    x1: 22.626,
    x2: 22.626,
    y1: 3.74,
    y2: 22.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E91A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedKlay5",
    x1: 37.924,
    x2: 24.623,
    y1: 26.54,
    y2: 2.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D0097",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D0097",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedKlay6",
    x1: 11.963,
    x2: 11.963,
    y1: -12.579,
    y2: 18.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E91A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C0000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedKlay7",
    x1: 18,
    x2: 6.428,
    y1: 22.072,
    y2: 11.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D0097",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9D0097",
    stopOpacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlay);
export default __webpack_public_path__ + "static/media/klay.66236e621be073af538f17cfc9a78f99.svg";
export { ForwardRef as ReactComponent };